import "../sass/campaign-landing/campaign-landing.scss";

var moment = require('./moment');

/**
 * Array.From polyfill
 */
 if (!Array.from) {
    Array.from = (function () {
      var toStr = Object.prototype.toString;
      var isCallable = function (fn) {
        return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
      };
      var toInteger = function (value) {
        var number = Number(value);
        if (isNaN(number)) { return 0; }
        if (number === 0 || !isFinite(number)) { return number; }
        return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
      };
      var maxSafeInteger = Math.pow(2, 53) - 1;
      var toLength = function (value) {
        var len = toInteger(value);
        return Math.min(Math.max(len, 0), maxSafeInteger);
      };
  
      // The length property of the from method is 1.
      return function from(arrayLike/*, mapFn, thisArg */) {
        // 1. Let C be the this value.
        var C = this;
  
        // 2. Let items be ToObject(arrayLike).
        var items = Object(arrayLike);
  
        // 3. ReturnIfAbrupt(items).
        if (arrayLike == null) {
          throw new TypeError("Array.from requires an array-like object - not null or undefined");
        }
  
        // 4. If mapfn is undefined, then let mapping be false.
        var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
        var T;
        if (typeof mapFn !== 'undefined') {
          // 5. else
          // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
          if (!isCallable(mapFn)) {
            throw new TypeError('Array.from: when provided, the second argument must be a function');
          }
  
          // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
          if (arguments.length > 2) {
            T = arguments[2];
          }
        }
  
        // 10. Let lenValue be Get(items, "length").
        // 11. Let len be ToLength(lenValue).
        var len = toLength(items.length);
  
        // 13. If IsConstructor(C) is true, then
        // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
        // 14. a. Else, Let A be ArrayCreate(len).
        var A = isCallable(C) ? Object(new C(len)) : new Array(len);
  
        // 16. Let k be 0.
        var k = 0;
        // 17. Repeat, while k < len… (also steps a - h)
        var kValue;
        while (k < len) {
          kValue = items[k];
          if (mapFn) {
            A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
          } else {
            A[k] = kValue;
          }
          k += 1;
        }
        // 18. Let putStatus be Put(A, "length", len, true).
        A.length = len;
        // 20. Return A.
        return A;
      };
    }());
  }
  
  /**
   * Countdown
   */
  const countdDownElement = document.getElementsByClassName('countdown-container')[0];

  if (countdDownElement) {
    let docDate = document.getElementById('campaign-enddate').value;
    let docDateISO = docDate.replace(/([+\-]\d\d)(\d\d)$/, "$1:$2");
    let eventDate = moment(docDateISO);
    
    // If it's not Daylight Saving Time, subtract 1 hour
    if (!eventDate.isDST()) {
      eventDate.subtract(1, "hour");
    }
    
    let hoursValue = document.getElementById('hours-value');
    let minutesValue = document.getElementById('minutes-value');
    let secondsValue = document.getElementById('seconds-value');
    
    function updateCountdown() {
      let now = moment();
      let timeToEvent = eventDate - now;
    
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
    
      if (timeToEvent < 0) {
        hours = 0;
        minutes = 0;
        seconds = 0;
      } else {
        hours = Math.floor(timeToEvent / 1000 / 3600);
        minutes = Math.floor((timeToEvent % (1000 * 60 * 60))/(1000 * 60));
        seconds = Math.floor((timeToEvent % (1000 * 60))/1000);
      }
    
      if (hoursValue && minutesValue && secondsValue) {
        hoursValue.innerHTML = '<span>' + pad(hours, 2).split('')[0] + '</span><span>' + pad(hours, 2).split('')[1] + '</span>';
        hoursValue.setAttribute('aria-label', hours);
        minutesValue.innerHTML = '<span>' + pad(minutes, 2).split('')[0] + '</span><span>' + pad(minutes, 2).split('')[1] + '</span>';
        minutesValue.setAttribute('aria-label', minutes);
        secondsValue.innerHTML = '<span>' + pad(seconds, 2).split('')[0] + '</span><span>' + pad(seconds, 2).split('')[1] + '</span>';
        secondsValue.setAttribute('aria-label', seconds);
      }
    }
    
    function pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    }
    
    updateCountdown();
    
    setInterval(function() {
      updateCountdown();
    }, 1000);
  }

  /**
   * Copy to clipboard
   */
  let copyBtn = document.getElementById('btn-code');
  if (copyBtn) {
    copyBtn.addEventListener('click', copyToClipboard);
  }
  
  
  function copyToClipboard() {
    const copyText = document.getElementById("code-value");
    const copyPlaceholder = document.getElementById("code-copy-placeholder");
    const copyResult = document.getElementById("code-copy-result");
  
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/
  
    /* Copy the text inside the text field */
    document.execCommand("copy");
  
    copyBtn.classList.add('copied');
    copyPlaceholder.classList.add('hide');
    copyResult.classList.remove('hide');
  
    /* Inform the user */
    setTimeout(function() {
      copyBtn.classList.remove('copied');
      copyPlaceholder.classList.remove('hide');
      copyResult.classList.add('hide');
    }, 1500);
  }
  
  
  /**
   * Feed controls
   */
  const leftBtns = document.getElementsByClassName('btn-feed-left');
  Array.from(leftBtns).forEach(function(element) {
    const feedId = element.getAttribute('data-target');
    element.addEventListener('click', function() { moveFeed('left', feedId) });
  });
  
  const rightBtns = document.getElementsByClassName('btn-feed-right');
  Array.from(rightBtns).forEach(function(element) {
    const feedId = element.getAttribute('data-target');
    element.addEventListener('click', function() { moveFeed('right', feedId) });
  });
  
  const moveFeed = function(direction, target) {
    const targetFeed = document.getElementById(target);
    const numberItems = document.getElementById('numberitems-'+ target).value;
    const maxScrollLeft = targetFeed.scrollWidth - targetFeed.clientWidth;
    const scrollOffset = 31;
    const itemsToJump = 3;
    const step = 11;
    const distance = (maxScrollLeft/numberItems + scrollOffset) * itemsToJump;
    const speed = 8;
  
    let scrollAmount = 0;
    const slideTimer = setInterval(function(){
      if(direction === 'left') {
        targetFeed.scrollLeft -= step;
      } else {
        targetFeed.scrollLeft += step;
      }
      scrollAmount += step;
      if(scrollAmount >= distance){
        window.clearInterval(slideTimer);
      }
    }, speed);
  }
  
  
  
  
  